import React from 'react';
import * as moment from 'moment';
// import * as Modal from 'react-modal';
// import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
// import FlatPagination from 'material-ui-flat-pagination';
import { Auth } from 'aws-amplify';
import loader from '../../images/Spin-1s-107px.gif';
import BannerHead from '../BannerHead';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import BigMoney from '../common/bigMoney';

class Transactions extends React.Component {
  state = {
    notificationLogId: null,
    offset: 0,
    isLoading: false,
    intervalId: 0,
    userId: localStorage.getItem('userId'),
  };

  /**
   * Load All Notifications
   */
  componentDidMount() {
    const { userId } = this.state;
    const data = {
      userId,
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: '',
    };
    this.props.getUserTransactionsHistory(data);
  }

  /**
   * Scroll to top off the page
   */
  componentWillMount() {
    if (localStorage.getItem('paymentStatus') === 'pending') {
      localStorage.clear();
      Auth.signOut()
        .then(async () => {
          await this.props.logoutUser();
          this.props.clearDataEmail();
          this.context.router.history.push('/');
        })
        .catch((error) => error);
    }

    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.setState({
      intervalId,
    });
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  componentDidUpdate() {
    // const { getTransactionsHistory } = this.props.data;
    // const { getTransactionsHistoryD, userId } = this.state;
    // if (notificationMarkCount !== notificationMarkCountD) {
    //   this.setState({
    //     getTransactionsHistoryD: getTransactionsHistory,
    //   });
    // }
  }

  /**
   * Paginate Notifications
   */
  getNotifications = async (offset) => {
    const { userId } = this.state;
    const pageNumber = offset / 5;
    this.setState({ offset, isLoading: true });
    await this.props.getAllNotifications({
      userId,
      pageNumber,
      pageSize: 5,
      searchKeyword: '',
    });
    this.setState({ offset, isLoading: false });
  };

  render() {
    const { getTransactionsHistory } = this.props.data;
    const { isLoading } = this.state;
    let amount
    let remainingBalance
    if (getTransactionsHistory.result) {
      console.log('getTransactionsHistory.result.records', getTransactionsHistory.result.records[0].remainingBalance.toFixed(2))
    }

    return (
      <div className='container'>
        {isLoading && (
          <div className='loader'>
            <img src={loader} alt='' />
          </div>
        )}

        <div className='main-content bg-grey'>
          <span>
            <div className='section-content dashboard'>
              <div className='row'>
                <div className='dashboard-tabs'>
                  <div className='row '>
                    <div className='section-content'>
                      <div className='row'>
                        <div className='dashboard-bg settlement-dashboardbg'>
                          <BannerHead title='Transactions' />
                        </div>
                        <div className='col s12'>
                          <div className='grid-outer transaction-grid'>
                            <Table className='highlight responsive-table'>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Transaction Date</TableCell>
                                  <TableCell>Settlement Name</TableCell>
                                  <TableCell>Amount</TableCell>

                                  <TableCell>Balance</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {getTransactionsHistory &&
                                  getTransactionsHistory.code === 400 ? (
                                    <TableRow className=''>
                                      <TableCell>Record not found</TableCell>
                                    </TableRow>
                                  ) : (
                                    getTransactionsHistory &&
                                    getTransactionsHistory.result &&
                                    getTransactionsHistory.result.records &&
                                    getTransactionsHistory.result.records.map(
                                      (iteam) => (
                                        <TableRow className=''>
                                          <TableCell>
                                            {moment(iteam.createdAt).format(
                                              'MM/DD/YY'
                                            )}
                                          </TableCell>
                                          <TableCell>
                                            {iteam.settlementName}
                                          </TableCell>
                                          <TableCell
                                            className={
                                              iteam.transactionType === 'Credit'
                                                ? 'credit'
                                                : 'debit'
                                            }
                                          >
                                            {' '}
                                            {iteam.transactionType === 'Credit'
                                              ? '+'
                                              : '-'}{' '}
                                            {amount = '$' + iteam.amount.toFixed(2)}
                                            {/* <BigMoney
                                              value={iteam.amount.toFixed(2)}
                                            /> */}
                                          </TableCell>
                                          <TableCell>
                                            {remainingBalance = '$' + iteam.remainingBalance.toFixed(
                                              2
                                            )}
                                            {/* <BigMoney
                                              value={iteam.remainingBalance.toFixed(
                                                2
                                              )}
                                            /> */}
                                            {' '}
                                          </TableCell>
                                        </TableRow>
                                      )
                                    )
                                  )}
                              </TableBody>
                            </Table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default Transactions;
